import React from "react"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"

export interface ChildImageSharp {
  childImageSharp: {
    gatsbyImageData: IGatsbyImageData
  }
}

export interface ImageProps {
  alt: string
  image: ChildImageSharp
}

export function Image({alt, image}: ImageProps) {
  return (
    <GatsbyImage alt={alt} image={image.childImageSharp.gatsbyImageData}/>
  )
}
